<div class="page-wrap">
  <div class="pinned">
    <div class="title">
      <nb-route-tabset [tabs]="tabs" [fullWidth]="true" [activeLinkOptions]="{exact: false}"></nb-route-tabset>
    </div>
    <div class="buttons">
      @if (count !== null) {
        <label class="count">{{ 'results' | plural:count | translate:{value: count} }}</label>
      }
    </div>
  </div>

  <bst-dual-axis [tag]="'quotes'" [delegate]="this" [bootstrap]="true" [pagingMode]="Globals.PagesMode"></bst-dual-axis>
</div>

<!-- bst-dual-axis sends clicks on standard cells to selectRow(), not clicks on the pinned one, so the number opens it itself. -->
<ng-template #cellTemplate let-quote="row" let-column="column" let-node="node">
  @switch (column.name) {
    @case ('number') { <a class="nowrap number" (click)="selectRow($event, node)">{{ quote.number }}</a> }
    @case ('version') { <span class="nowrap">{{ 'quotes.version' | translate:{n: quote.version} }}</span> }
    @case ('status') { <bst-quote-status [status]="quote.status"></bst-quote-status> }
    @case ('organisation') { <span [title]="quote.organisation.name ?? ''">{{ quote.organisation.name }}</span> }
    @case ('title') { <span [title]="quote.title">{{ quote.title }}</span> }
    @case ('responsible') { @if (quote.responsible) { <span class="nowrap">{{ quote.responsible.name }}</span> } @else { <span class="muted">–</span> } }
    @case ('quote_date') { <span class="nowrap">{{ quote.quote_date | localedate:'D MMM YYYY' }}</span> }
    @case ('expires_on') { <span class="nowrap">{{ quote.expires_on | localedate:'D MMM YYYY' }}</span> }
  }
</ng-template>

<!-- Phone width: one card per quote; bst-dual-axis sends its click to selectRow(). -->
<ng-template #cardTemplate let-quote="row">
  <div class="q-card">
    <div class="q-card-head">
      <strong>{{ quote.number }} <span class="muted">{{ 'quotes.version' | translate:{n: quote.version} }}</span></strong>
      <bst-quote-status [status]="quote.status"></bst-quote-status>
    </div>
    <div class="q-card-meta"><span>{{ quote.organisation.name }}</span><span class="nowrap">{{ quote.expires_on | localedate:'D MMM YYYY' }}</span></div>
    <div class="q-card-sub">{{ quote.title }}</div>
  </div>
</ng-template>
